import React from 'react'
import {Link} from 'react-router-dom'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import './styles/normativa.css'

const TEMAS_MIGRACION = [
  {
    titulo: 'Trámites ante el Ministerio de Hacienda',
    detalle:
      'Su empresa debe realizar ante el Ministerio de Hacienda las gestiones que habilitan la emisión con la versión 2. Mientras no cuente con esa habilitación, no debe cambiar de versión en la plataforma.',
  },
  {
    titulo: 'Pruebas previas a la emisión en producción',
    detalle:
      'Realice las pruebas que el Ministerio de Hacienda le requiera y confirme que los documentos de su operación se transmiten correctamente con la versión 2 antes de emitir a sus clientes.',
  },
  {
    titulo: 'Modalidad de correlativo',
    detalle:
      'Debe elegir si el correlativo de sus documentos será centralizado, es decir una sola numeración para toda la empresa, o por establecimiento, una numeración independiente para cada establecimiento. La modalidad que elija se informa al Ministerio de Hacienda y determina cómo se numeran sus documentos.',
  },
  {
    titulo: 'Cambio de series y del número de control',
    detalle:
      'La versión 2 modifica el formato del número de control, por lo que las series con las que emite hoy se reemplazan por series con el formato nuevo. Revise la serie de cada documento de cada establecimiento antes de cambiar de versión.',
  },
  {
    titulo: 'Migración territorial de su cartera de clientes',
    detalle:
      'La versión 2 sustituye el municipio por el distrito en la dirección del receptor. Debe actualizar la dirección de los clientes que ya tiene registrados para que indique el distrito que les corresponde.',
  },
]

const CONSECUENCIAS_CAMBIO = [
  'Los documentos que emita después del cambio se generan con la versión 2 y con las series del formato nuevo.',
  'Los documentos que ya emitió conservan la versión con la que fueron emitidos y no se modifican.',
  'Si necesita detener la migración, puede regresar a la versión 1 desde la misma pantalla de alistamiento.',
  'Después de cambiar de versión, cierre su sesión y vuelva a ingresar para que la plataforma trabaje con la versión nueva.',
]

const InformacionNormativa = () => {
  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/home'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Normativa 2.0 del Ministerio de Hacienda</h3>
      </div>
      <div className='separador'></div>
      <div
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{height: 'auto'}}>
            <div className='w-layout-vflex card-content'>
              <div className='normativa-bloque'>
                <h3 className='card-title l'>Qué es la normativa 2.0</h3>
                <p className='normativa-texto m'>
                  El Ministerio de Hacienda estableció una versión nueva de los documentos
                  tributarios electrónicos. A partir del 1 de diciembre de 2026 todos los documentos
                  deben emitirse con la versión 2, por lo que su empresa debe completar la migración
                  antes de esa fecha.
                </p>
              </div>

              <div className='normativa-aviso'>
                <p className='normativa-aviso-titulo m'>La gestión le corresponde a su empresa</p>
                <p className='m'>
                  La plataforma le provee la funcionalidad para emitir con la versión 2 y para
                  revisar si su empresa está lista. Los trámites, las autorizaciones, las pruebas y
                  las decisiones que el Ministerio de Hacienda le solicite son responsabilidad de su
                  empresa. Nosotros no realizamos esas gestiones en su nombre.
                </p>
              </div>

              <div className='normativa-bloque'>
                <h3 className='card-title l'>Qué conlleva migrar a la versión 2</h3>
                <ul className='normativa-lista'>
                  {TEMAS_MIGRACION.map((tema) => (
                    <li key={tema.titulo} className='normativa-item'>
                      <p className='normativa-item-titulo m'>{tema.titulo}</p>
                      <p className='normativa-texto m'>{tema.detalle}</p>
                    </li>
                  ))}
                </ul>
              </div>

              <div className='normativa-bloque'>
                <h3 className='card-title l'>Qué ocurre cuando cambia de versión</h3>
                <ul className='normativa-lista'>
                  {CONSECUENCIAS_CAMBIO.map((consecuencia) => (
                    <li key={consecuencia} className='normativa-item'>
                      <p className='normativa-texto m'>{consecuencia}</p>
                    </li>
                  ))}
                </ul>
              </div>

              <div className='form-separator'></div>

              <div className='normativa-acciones'>
                <Link
                  to={'/normativa/alistamiento'}
                  className='m button w-inline-block'
                  style={{textDecoration: 'none'}}
                >
                  <div>Revisar el alistamiento de su empresa</div>
                </Link>
                <Link
                  to={'/home'}
                  className='m button transparent w-inline-block'
                  style={{textDecoration: 'none'}}
                >
                  <div>Regresar al inicio</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default InformacionNormativa
